// Importing the necessary types
import {
  IAdditionalManagersUsersListResponse,
  IGetDailyReportService,
} from "../../../Types/DailyReport";
import { IBaseResponse } from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

enum DailyReportEndpoints {
  GET_REPORT = "/employee/daily-report",
}

// Defining the DailyReportService class that extends the ApiService class to interact with the daily report-related API
class DailyReportService extends ApiService {
  async getDailyReport(id?: string): Promise<IGetDailyReportService> {
    return this.get<Promise<IGetDailyReportService>>(
      `${DailyReportEndpoints.GET_REPORT}${id ? `/${id}` : ""}`
    );
  }

  // Method to upload a daily report using a FormData object
  async uploadDailyReport(
    dailyReportFormData: FormData
  ): Promise<IBaseResponse> {
    return this.post<Promise<IBaseResponse>>(
      DailyReportEndpoints.GET_REPORT,
      dailyReportFormData
    );
  }

  // Method to download a daily report file from a specified file path
  async downloadDailyReport(filePath: string) {
    const uthoService = new ApiService(
      `${process.env.REACT_APP_UTHO_BUCKET_URL}?path=${filePath}`,
      undefined,
      process.env.REACT_APP_UTHO_API_KEY
    );
    return uthoService.get<{ status: string; url: string }>();
  }

  // Method to fetch Additional Managers List
  async getUsersList(params?: {
    manager: boolean | number;
    page?: number;
    size?: number;
    name?: string;
    status?: number;
    email?: string;
  }): Promise<IAdditionalManagersUsersListResponse> {
    const queryParams = new URLSearchParams();

    if (params?.manager !== undefined)
      queryParams.append("manager", String(params.manager as Boolean));
    if (params?.page) queryParams.append("page", String(params.page));
    if (params?.size) queryParams.append("size", String(params.size));
    if (params?.status) queryParams.append("status", String(params.status));
    if (params?.name) queryParams?.append("name", params.name);
    if (params?.email) queryParams?.append("email", params.email);

    const queryString = queryParams.toString();
    const url = `/users${queryString ? `?${queryString}` : ""}`;

    return this.get<IAdditionalManagersUsersListResponse>(url);
  }
}

// Creating an instance of the DailyReportService class and exporting it for use in other parts of the application
export const dailyReportService = new DailyReportService();
